import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyPagination,
	//MyButton,
	//MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Updatedlog 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaob  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	/*const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0);

	const [uDatamainObj,setDatamainObj]		= React.useState({})//-*/

	//--DLG_FORM--/
	//--END DLG_FORM--/

	const uDatalogsArr	= [
		{version:"4.15.4",updated_arr:[
			{teks_menu:"Aplikasi",teks_content:"Pindah Server Cloud."},
		],tgl_updated:"2026-09-18"},
		{version:"4.15.3",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent >> Form Consent 1 dan 2",teks_content:"Update Fitur, Penyempurnaan Form Informed Consent."},
		],tgl_updated:"2025-02-12"},
		{version:"4.15.2",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent >> Form Consent 2",teks_content:"Update Fitur, Menambahkan Auto Filled Consent, ketika Memilih TINDAKAN.<br/>Dan secara HYBRID Sistem akan menyimpan Data Consent Terakhir yang diinputkan untuk tiap-tiap Dokter."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent >> Form Consent 1",teks_content:"Update Fitur, Menambahkan Auto Filled Consent, ketika Memilih TINDAKAN.<br/>Dan secara HYBRID Sistem akan menyimpan Data Consent Terakhir yang diinputkan untuk tiap-tiap Dokter."},
		],tgl_updated:"2025-02-10"},
		{version:"4.15.1",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent >> Form Consent 2",teks_content:"Update Fitur, Menambahkan Fitur Form Input Jenis PEMBERIAN INFORMASI dan PERSETUJUAN TINDAKAN BEDAH / MEDIK."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent >> Form Consent 1",teks_content:"Update Fitur, Penyempurnaan Fitur Tandatangan."},
			{teks_menu:"Master Data >> Setting >> Konfigurasi Klinik",teks_content:"Update Fitur, Menambahkan Data Email Klinik dan Kota untuk keperluan Informed Consent."},
		],tgl_updated:"2025-02-06"},
		{version:"4.15.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent",teks_content:"Update Fitur, Menambahkan Fitur Data Consent Klinik."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Informed Consent",teks_content:"Update Fitur, Menambahkan Fitur Histori Consent Pasien."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Consent >> Form Consent 1",teks_content:"Update Fitur, Menambahkan Fitur Form Input Jenis PEMBERIAN INFORMASI."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Rekam Medis",teks_content:"Update Fitur, Menambahkan Link Navigasi Informed Consent Pasien."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Foto Pasien",teks_content:"Update Fitur, Menambahkan Link Navigasi Informed Consent Pasien."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Form Reservasi",teks_content:"Update Fitur, Menambahkan Link Navigasi Informed Consent Pasien."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Status Kunjungan",teks_content:"Update Fitur, Menambahkan Link Navigasi untuk Buat Consent Baru."},
		],tgl_updated:"2025-01-28"},
		{version:"4.14.2",updated_arr:[
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Daftar Reservasi ",teks_content:"Update FITUR, Daftar Kalender Klinik untuk DOKTER Tidak Ditampilkan.<br/>Menampilkan Badge Asuransi yang digunakan Pasien."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Status Kunjungan ",teks_content:"Update FITUR, Menampilkan Badge Asuransi yang digunakan Pasien."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Jadwal Perawat ",teks_content:"Update FITUR, Memindahkan Menu Jadwal Perawat ke Kunjungan Pasien, untuk Keperluan Fitur CONSENT Klinik."},
		],tgl_updated:"2025-01-09"},
		{version:"4.14.1",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Pasien >> Billing Periksa",teks_content:"Update BUG, memperbaiki posisi Odontogram Gigi bawah, yang terbalik kuadran-nya."},
		],tgl_updated:"2025-10-24"},
		{version:"4.14.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Pasien >> Billing Periksa",teks_content:"Update Fitur, Menambahkan Modul Rating Perawat, Subjective, Objective, Odontogram Gigi, Assesment, dan PLAN."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Rekam Medis",teks_content:"Update Fitur, Mengubah Tampilan Tabel Rekam Medis dan View Detil Rekam Medis dengan Data-data SOAP.<br/>Memberi Approval Edit RM kepada DOKTER Bersangkutan."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Rekam Medis >> Edt Rekam Medis",teks_content:"Update Fitur, Mengubah Form Edit Rekam Medis dengan Data-data SOAP."},
			{teks_menu:"Laporan >> Klinik >> Laporan Perawat",teks_content:"Update Fitur, Mengubah Format Laporan Perawat, dengan menambahkan Rating dan Catatan Perawat."},
		],tgl_updated:"2025-10-23"},
		{version:"4.13.0",updated_arr:[
			{teks_menu:"Master Data >> Data Sistem >> Data Perawat",teks_content:"Update Fitur, Menambahkan Aproval Cabang untuk Masing-masing Perawat."},
		],tgl_updated:"2025-09-23"},
		{version:"4.12.2",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update BUG, Fixing Auto Redirect ke Kalender."},
		],tgl_updated:"2025-07-07"},
		{version:"4.12.1",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update BUG, Lebar Dropdown Show Kalender Bermasalah."},
			{teks_menu:"Login Sistem",teks_content:"Update BUG, Password Warning untuk alasan Keamanan Sistem."},
			{teks_menu:"Api User Update",teks_content:"Update BUG, Pengecekan Password untuk alasan Keamanan Sistem."},
		],tgl_updated:"2025-07-02"},
		{version:"4.12.0",updated_arr:[
			{teks_menu:"Laporan >> Klinik >> Laporan Pasien Baru",teks_content:"Update Fitur, Tambah Laporan Pasien Baru dan Lama untuk Tiap Range Tanggal."},
			{teks_menu:"Klinik Sistem >> Data Kunjungan >> Daftar Reservasi",teks_content:"Update Fitur, Tambah CARD Data Kalender sesuai Tanggal Antrian."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir >> Input Pembayaran",teks_content:"Update Fitur, Menambahkan Icon untuk melihat Kalender singkat."},
		],tgl_updated:"2025-06-29"},
		{version:"4.11.0",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update FITUR, Menambahkan Summary Kalender Klinik."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Kalender Klinik",teks_content:"Update Fitur, Menambahkan Fitur Kalender Klinik Untuk Reminder Klinik dan Dokter Jika Berhalangan.<br/>Untuk Dokter semua Reservasi Pasien juga ditampilkan."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Reservasi Pasien",teks_content:"Update Fitur, Menghubungkan Kalender Klinik Tgl Not Available dengan Filter Pembatasan/Pemblokiran TGL RESERVASI Pasien."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir >> Input Pembayaran",teks_content:"Update Fitur, Menghubungkan Kalender Klinik Tgl Not Available dengan Filter Pembatasan/Pemblokiran TGL RESERVASI Pasien."},
		],tgl_updated:"2025-06-22"},
		{version:"4.10.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Pasien >> Rekam Medis Pasien",teks_content:"Update BUG, Memperbaiki Data Pembayaran dari Detil View, sesuai Cabang yang di-load."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Billing Periksa",teks_content:"Update Fitur, Memindahkan Input Reservasi Pasien Berikutnya, ke Menu Pembayaran Kasir."+
				"<br/>Pada Modul Ini Dokter hanya dapat memberikan NOTE kepada FO."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Reservasi Pasien",teks_content:"Update Fitur, Mengubah Form Reservasi dengan Komponen yang dapat Dipakai Modul Lain."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir >> Input Pembayaran",teks_content:"Update Fitur, Menambahkan Modul Reservasi Berikutnya ketika Pembayaran Kasir."},
		],tgl_updated:"2025-06-15"},
		{version:"4.9.1",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update BUG, Ketika Login FO, Jumlah Pasien Hari ini Salah."},
			{teks_menu:"Api >> Login",teks_content:"Update BUG, Ketika Login FO, Jika Sudah Login Tempat Lain Masih bisa masuk.<br/>Ketika Logout, Init token Lain juga harus dibersihkan."},
			{teks_menu:"Api >> userInitStatus",teks_content:"Update FITUR, Ketika Cek Token API, Sebelumnya Nomor IP juga dicek, namun menimbulkan masalah ketika menggunakan DATA SELULER, yang IP-nya selalu berubah."},
		],tgl_updated:"2025-03-15"},
		{version:"4.9.0",updated_arr:[
			{teks_menu:"Laporan >> Klinik >> Laporan Kinerja Dokter",teks_content:"Update Fitur, Tambah Laporan Kinerja Dokter untuk Tiap Range Tanggal."},
		],tgl_updated:"2025-03-15"},
		{version:"4.8.3",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Kunjungan >> Reservasi Kadaluwarsa",teks_content:"Update Fitur, Menampilkan User yang Menginput."},
		],tgl_updated:"2025-03-15"},
		{version:"4.8.2",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Kunjungan >> Daftar Reservasi",teks_content:"Update Fitur, Tambah Status RSVP untuk CANCELED dan RESCHEDULED."},
		],tgl_updated:"2025-03-15"},
		{version:"4.8.1",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Kunjungan >> Daftar Reservasi",teks_content:"Update Fitur, Tampilan Ruangan diubath menjadi per 15 Menit."+
			"<br/>Tanggal Sebelumnya Menampilkan Sisa Reservasi Pasien."+
			""},
		],tgl_updated:"2025-03-14"},
		{version:"4.8.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Daftar Reservasi",teks_content:"Update Fitur, Status RSVP: BOOKING BIASA, TERKONFIRMASI, HADIR."+
				"<br/>Sub Header Filter, langsung eksekusi ketika Ada Aksi, Tanpa mengeklik TOMBOL CARI."+
				"<br/>Mode Display Untuk FO Format Ruangan per Hari, dengan TOGGLE MODE Display, sesuai Pilihan."+
				"<br/>Untuk Mode Display per-RUANG, Jam Janjian Dibuat per-setengah-jam."+
				"<br/>Kirim WA,dengan Format Template yang dapat diatur."+
				"<br/>Ditambah Notifikasi ULANG TAHUN di-sebelah NAMA PASIEN."+
				""},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Reservasi Pasien",teks_content:"Update Fitur, Update Status RSVP, ketika Input Reservasi."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Status Pasien",teks_content:"Update Fitur, Kirim Follow Up WA.<br/>Tambah Jam Janjian di-bawah NAMA DOKTER."},
			{teks_menu:"Master Data >> Setting >> Konfigurasi Klinik",teks_content:"Update Fitur, Menambahkan Konfigurasi WA pada modul ini, dan memindahkan Konfigurasi Aplikasi Pada Menu Tersendiri."},
			{teks_menu:"Master Data >> Setting >> Konfigurasi Aplikasi",teks_content:"Update Fitur, memindahkan Setting Data General Aplikasi pada Modul Ini."},
			{teks_menu:"Dashboard",teks_content:"Update Fitur, Tombol Refresh untuk beberapa SECTION CARD."},
		],tgl_updated:"2025-03-04"},
		{version:"4.7.1",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update BUG, Perbaikan Omzet Hari Ini dan Perubahan Pencairan POIN Perawat."},
		],tgl_updated:"2025-01-10"},
		{version:"4.7.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Data Pasien >> Rekam Medis",teks_content:"Update Fitur, Ketika Sudah DISET Periksa Harus bisa membuka Fitur Foto Pasien."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Foto Pasien",teks_content:"Update Fitur, Menyesuaikan Ketika Pasien Sedang DISET Periksa."},
			{teks_menu:"Laporan >> Operasional >> Lap.Rekap Kunjungan",teks_content:"Update Fitur, Tambah Laporan Rekap Kunjungan untuk Menampilkan Durasi Kunjungan Pasien."},
			{teks_menu:"Laporan >> Klinik >> Laporan Perawat",teks_content:"Update Fitur, Poin Perawat DIKELUARKAN pada Tanggal yang Sama dengan Tgl Kunjungan. Tidak Melihat Pelunasan Pasien maupun Klaim Asuransi."},
		],tgl_updated:"2025-01-08"},
		{version:"4.6.0",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update Fitur, Menampilkan Dashboard dengan Fitur Informasi Terbaru."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Status Kunjungan",teks_content:"Update Fitur, Tambah Status Baru yaitu <b>BILING</b>.<br/>Tiap-tiap Status Waktu SET-nya DITAMPILKAN."},
			{teks_menu:"Klinik Sistem >> Data Pasien >> Billing Periksa",teks_content:"Update Fitur, Proses SET Time untuk Waktu Billing Periksa."},
			{teks_menu:"Laporan >> Klinik >> Laporan Perawat",teks_content:"Update Fitur, Untuk Laporan Tiap Perawat, Ditampilkan DETIL Item Poin Tiap-tiap Terapi."},
			{teks_menu:"Laporan >> Operasional >> Lap.Rekap Asuransi",teks_content:"Update Fitur, Tambah Laporan Rekap Asuransi dengan format seperti Lap.Piutang."},
		],tgl_updated:"2025-01-06"},
		{version:"4.5.2",updated_arr:[
			{teks_menu:"ROOT Menu",teks_content:"Update Fitur, Mengganti metode pembaruan Session."},
		],tgl_updated:"2024-12-07"},
		{version:"4.5.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Input / Edit Pasien",teks_content:"Update Fitur, Tambahan Administrasi Wilayah Pasien, untuk Keperluan Registrasi IHS Number Satusehat."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Status Kunjungan",teks_content:"Update Fitur, Tambahan Administrasi Wilayah Pasien, untuk Keperluan Registrasi IHS Number Satusehat."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir >> Input Pembayaran",teks_content:"Update Fitur, Bisa Menambahkan Item UNLIMITED.<br/>Merubah QTY dan DISKON.<br/>Tambah Catatan KASIR."},
			{teks_menu:"Klinik Sistem >> Kasir >> Rekap Nota",teks_content:"Update Fitur,Nomor GIGI, Catatan Kasir dan Catatan Keterangan Payment, Dimunculkan di NOTA."},
		],tgl_updated:"2024-12-06"},
		{version:"4.4.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Billing Periksa",teks_content:"Update Fitur, Untuk Asuransi yang ditentukan Maksimal Jumlah Terapi-nya."+
				"<br/>Diskon Total Dihilangkan, Diganti DISKON PER ITEM, dengan PERSENTASE Tetap DIBATASI."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir >> Input Pembayaran",teks_content:"Update Fitur, View Nomor Asuransi.<br/>Multiple Jenis METODE PEMBAYARAN Dalam SATU NOTA.<br/>Diskon Total Dihilangkan, dan memunculkan DISKON per Item Terapi."},
			{teks_menu:"Klinik Sistem >> Kasir >> Bayar Cicilan Pasien",teks_content:"Update Fitur, Load Detil Item, Menampilkan Diskon per Item Terapi."},
			{teks_menu:"Klinik Sistem >> Kasir >> Rekap Nota",teks_content:"Update Fitur, View Multiple Jenis METODE PEMBAYARAN Dalam SATU NOTA.<br/>Diskon Total Dihilangkan, dan memunculkan DISKON per Item Terapi."},
			{teks_menu:"Laporan >> Operasional >> Laporan Kasir",teks_content:"Update Fitur, View Rincian Item Terapi Tiap Transaksi dengan Diskon Terapinya, dan Menyesuaikan Multiple Metode Pembayaran."},
			{teks_menu:"Laporan >> Operasional >> Laporan Laba/Rugi",teks_content:"Update Fitur, Menyesuaikan Diskon Tiap Terapi, dan Multiple Biaya Payment dari masing-masing metode pembayaran."},
			{teks_menu:"Laporan >> Klinik >> Laporan Fee Dokter",teks_content:"Update Fitur, Menyesuaikan Diskon Tiap Terapi, dan Multiple Biaya Payment dari masing-masing metode pembayaran."},
			{teks_menu:"Laporan >> Klinik >> Laporan Terapi",teks_content:"Update Fitur, Menyesuaikan Diskon Tiap Terapi."},
		],tgl_updated:"2024-11-22"},
		{version:"4.3.0",updated_arr:[
			{teks_menu:"Master Data >> Data Sistem >> Tarif Terapi",teks_content:"Update Fitur, Untuk HAK User DOKTER Hanya bisa melihat TOTAL Tarif."},
			{teks_menu:"Master Data >> Data Sistem >> Data Asuransi",teks_content:"Update Fitur, Tiap Asuransi diberi batasan Jumlah Maksimal Terapi."},
			{teks_menu:"Klinik Sistem >> Pasien >> Input Pasien",teks_content:"Update Fitur, Nomor Asuransi Pasien."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Dialog Pasien",teks_content:"Update Fitur, Memunculkan No.Asuransi Pasien."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Daftar Pasien",teks_content:"Update Fitur, SET Kehadiran Berlaku ke SEMUA Window yang Saat Tebuka Bersamaan."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Rekam Medis",teks_content:"Update Fitur, Tampilan Dibuat simultan seluruh Cabang, tidak lagi per Cabang saja."},
		],tgl_updated:"2024-11-15"},
		{version:"4.2.x",updated_arr:[
			{teks_menu:"Aplikasi",teks_content:"Seluruh Update Terakhir yang BELUM terdokumentasi."},
		],tgl_updated:"2024-11-14"},
	]
	const uJmlData	= uDatalogsArr.length;

	//---HANDEL--/
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentMain = () => {
		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);

		const vDataviewArr	= uDatalogsArr.slice(vMin,(vMax));

		return (
		<>
		{vDataviewArr.map((vItems,vKeys)=>{
			const vItemsArr	= vItems.updated_arr || [];

			return (
			<CCard className="mb-3 classbgcard" key={vKeys}>
			<CCardHeader className="d-flex justify-content-between">
				<div>Ver: <b>{vItems.version}</b></div>
				<div className="classfontsmaller"><small>{UFunc.HariAngka(vItems.tgl_updated)}</small></div>
			</CCardHeader>
			<CCardBody>
			<ul>
			{vItemsArr.map((vItemcontent,vKeycontent)=>{
				return (
				<li key={vKeycontent}>
					<div className="fw-bolder">{vItemcontent.teks_menu}</div>
					<small className="d-block fst-italic">{UFunc.renderHTML(vItemcontent.teks_content)}</small>
				</li>
				)//>
			})}
			</ul>
			</CCardBody>
			</CCard>
			)//>
		})}
		</>
		)//>
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = () => {}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
    	
    	apiLoaddata();

    	return () => {
    		setPageActive(1);
    	}
	},[])
	//---END EFFECT--/

	//console.log("(Updatedlog) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-4 p-0">
		<CContainer fluid className="classheadertop border-bottom"
			style={{height:64}}>
			<CHeaderToggler className="px-0" onClick={()=>uNavigate(-1)}>
			<CIcon icon="cilArrowCircleLeft" className="align-middle me-2" height={30}/>
			</CHeaderToggler>

			<CHeaderBrand className="me-auto">
				<small className="fw-bolder">
				Updated Logs<span className="d-none d-md-inline ms-1">{pjson.name}</span>
				</small>
			</CHeaderBrand>

			<CHeaderNav className="">
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-1 px-md-2 px-lg-5">
		<CContainer xxl className="px-0 mb-3">
			{contentMain()}

			{(uJmlData > uMaxData) && (
			<CCard>
			<CCardBody>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardBody>
			</CCard>
			)}
		</CContainer>
		</div>
		</div>
		</>
	)//>
}	

export default Updatedlog